import { request } from './api/http'

/**
 * Hosted assistants (Claude, ChatGPT) connect by signing in to Rithmo (OAuth), not with a token. Their connection journey
 * is shown only in a build that turns it on (VITE_HOSTED_CONNECTORS=on) for live acceptance on an environment where the
 * sign-in is configured; everywhere else they are shown as not available yet.
 */
export const hostedConnectors = (): boolean => import.meta.env.VITE_HOSTED_CONNECTORS === 'on'

let address: Promise<string> | null = null
/**
 * The MCP address every agent and every host connects to, as the server serves it at run time (its public MCP front
 * door, the resource its sign-in names). Never a build-time value and never this dashboard's own address: when the server
 * has none, this fails and the Connect controls show an error instead of a wrong link.
 */
export function publicMcpAddress(): Promise<string> {
  if (!address) address = request<{ mcpUrl?: string }>('/agents/mcp-address').then((r) => {
    if (typeof r?.mcpUrl !== 'string' || !/^https?:\/\//.test(r.mcpUrl)) throw new Error('mcp_address_unavailable')
    return r.mcpUrl
  }).catch((e) => { address = null; throw e })
  return address
}

/** Claude's add-connector deep link for the MCP address (a person's own, or the org-wide admin one). */
export const claudeConnectorUrl = (mcpUrl: string, admin = false): string =>
  `https://claude.ai/${admin ? 'admin-settings' : 'customize'}/connectors?modal=add-custom-connector&connectorName=Rithmo&connectorUrl=${encodeURIComponent(mcpUrl)}`
/** ChatGPT has no prefill: it is opened, and the MCP address is pasted. */
export const CHATGPT_URL = 'https://chatgpt.com'
